import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import LocalizedText from '@LocalizedText';
import { HELP_SECTION_PRODUCT_TYPE, HELP_TOPIC_CONTACT_US, HELP_PRODUCT_TYPES_LABELS } from '@app/constants';
import { setLabelTypePart } from '@app/utils/help';

const ProductTypeSection = ({ activeTopic, scrollToTopic, isRoll, isDesignIn, isStickerFlow, isSheetFlow }) => {
  const labelTypePart = setLabelTypePart(HELP_PRODUCT_TYPES_LABELS, [isRoll, isStickerFlow, isSheetFlow]);

  useEffect(() => {
    activeTopic && scrollToTopic(activeTopic);
  }, [activeTopic, scrollToTopic]);

  return (
    <div id={HELP_SECTION_PRODUCT_TYPE} className="help-section">
      <div className="section-topic">
        <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}`} tagName="h2" />
        <div>
          <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-p1`} tagName="p" />
          {(isDesignIn || isSheetFlow) && (
            <>
              <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-p2`} tagName="p" />
              <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-p3`} tagName="p" />
              <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-p4`} tagName="p" />
              <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-p5`} tagName="p" />
            </>
          )}
        </div>
      </div>
      <div id={HELP_TOPIC_CONTACT_US} className="section-topic">
        <LocalizedText id="qau-help-topic-contact-us" tagName="h3" />
        <div>
          {!isDesignIn && <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-contact-us-p1`} tagName="p" />}
          <div className="contact-us-info">
            <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-contact-us-phone`} tagName="p" />
            <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-contact-us-workhours`} tagName="p" />
            {isDesignIn && <LocalizedText id={`qau-help-topic-product-type-${labelTypePart}-contact-us-email`} tagName="p" />}
          </div>
        </div>
      </div>
    </div>
  );
};

ProductTypeSection.propTypes = {
  scrollToTopic: PropTypes.func.isRequired,
  activeTopic: PropTypes.string,
  isRoll: PropTypes.bool.isRequired,
  isSheetFlow: PropTypes.bool.isRequired,
  isStickerFlow: PropTypes.bool.isRequired,
};

export default ProductTypeSection;
